// extracted by mini-css-extract-plugin
module.exports = {"emptyList":"empty-patients-list_emptyList__1HsWc"};